import styled from 'styled-components'

export const Wrapper = styled.header`
  position: relative;
  z-index: 1301;
`
